import axios from 'axios'
import env from "../../env"
// import Swal from 'sweetalert2'

export const fetchApps = () => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      dispatch({ type: 'SET_APPS', payload: []})
        axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/app`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          }    
        })
          .then(response => {
              dispatch({ type: 'SET_APPS', payload: response.data.apps})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const fetchApp = (appId) => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      dispatch({ type: 'SET_APP', payload: {}})
        axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/app/${appId}`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          }    
        })
          .then(response => {
            dispatch({ type: 'SET_APP', payload: response.data.app})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const fetchCustomerApps = (appId) => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      dispatch({ type: 'SET_CUSTOMERS', payload: []})
        axios({
          method:'get',
          url: `${env.REACT_APP_BE_URL}/app/customers/${appId}`,
          headers: {
            authorization: `Bearer ${localStorage.getItem('access_token')}`
          }    
        })
          .then(response => {
              dispatch({ type: 'SET_CUSTOMERS', payload: response.data.customers})
          })
          .catch(error => {
            dispatch({ type: 'SET_ERROR', payload: error})
          })
          .finally(_ => {
            dispatch({ type: 'SET_LOADING', payload: false })
          })
    }
}

export const createApp = (data) => {
  return (dispatch, getState) => {
    axios({
      method:'post',
      url: `${env.REACT_APP_BE_URL}/createApp`,
      data,
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    })
      .then(response => {
        console.log(response.data,'<<<<<<<<');
      })
      .catch(error => {
        console.log(error);
      })
      .finally(_ => {
      })
  }
}

export const updateApp = (data) => {
  return (dispatch, getState) => {
    axios({
      method:'put',
      url: `${env.REACT_APP_BE_URL}/updateApp/${data.get('appId')}`,
      data,
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    })
      .then(response => {
        console.log(response.data);
      })
      .catch(error => {
        console.log(error);
      })
      .finally(_ => {
      })
    }
}

export const showStatisticSummaries = (data) => {
  return (dispatch, getState) => {
    dispatch({ type: 'SET_STATS', payload: {}})
    axios({
      method:'post',
      url: `${env.REACT_APP_BE_URL}/app/reportSummaries`,
      data,
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    })
      .then(response => {
        if (response.data.message === 'Log data not found') {
          dispatch({ type: 'SET_STATS', payload: {}})
        }
        dispatch({ type: 'SET_STATS', payload: response.data})
      })
      .catch(error => {
        console.log(error,'<<<<');
      })
      .finally(_ => {
      })
    }
}

export const setChartData = (data) => {
  return (dispatch, getState) => {
    dispatch({ type: 'SET_CHART_DATA', payload: {}})
    axios({
      method:'post',
      url: `${env.REACT_APP_BE_URL}/app/timeFrame`,
      data,
      headers: {
        authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    })
      .then(response => {
        if (response.data.message === 'Log data not found') {
          dispatch({ type: 'SET_CHART_DATA', payload: {}})
        }
        dispatch({ type: 'SET_CHART_DATA', payload: response.data})
      })
      .catch(error => {
        console.log(error,'<<<<');
      })
      .finally(_ => {
      })
    }
}


export const cleanup = () => {  
  return (dispatch, getState) => {
      dispatch({ type: 'SET_LOADING', payload: true })
      dispatch({ type: 'SET_APP', payload: {}})
  }
}

export const refetch = (data) => {  
  return (dispatch, getState) => {
      console.log(data);
      // dispatch({ type: 'SET_LOADING', payload: false })
      // dispatch({ type: 'SET_APP', payload: data})
  }
}


// export const destroyApp = (id , token) => {
//   return (dispatch, getState) => {
//     }
// }